/** Shared Intercom messenger shell dimensions and corner radii. */

export const INTERCOM_SHELL_RADIUS = 'rounded-2xl';

export const INTERCOM_SHELL_CLASS = `h-full w-full overflow-hidden ${INTERCOM_SHELL_RADIUS} bg-white shadow-[0_5px_40px_rgba(9,14,21,0.16)] dark:bg-n-solid-1`;

export const INTERCOM_CARD_RADIUS = 'rounded-xl';

export const INTERCOM_BUTTON_RADIUS = 'rounded-[10px]';

export const INTERCOM_COMPOSER_RADIUS = 'rounded-2xl';

export const INTERCOM_BUBBLE_RADIUS = 'rounded-[20px]';

/** Intercom bot / AI avatar (squircle). */
export const INTERCOM_BOT_AVATAR_RADIUS = 'rounded-[16.7%]';

/** Human agent avatars are always circular. */
export const INTERCOM_AGENT_AVATAR_RADIUS = 'rounded-full';

export const INTERCOM_AVATAR_RADIUS = INTERCOM_BOT_AVATAR_RADIUS;
